import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import SavingPotsActionCreator from '../actions/SavingPotsActionCreator';
import MoveMoneyActionCreator from '../actions/MoveMoneyActionCreator';
import AccountsActionCreator from '../actions/AccountsActionCreator';
import UserManagementStore from '../stores/UserManagementStore';

const _getPotsDataEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/pots';
const _singlePotEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/pots/{pot-id}';
const _interPotEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/pots/transactions';

const _getAccountListEndpoint = '/ibapi/v2/banks/{bank-id}/accounts/default';

const SavingsPotsUtils = {
  /**
   * API call for getAccoountList.
   * Retrieves the list of accounts for a customer.
   */
  getAccountsList() {
    let url = envConfig.apiBaseUrlPAAS + _getAccountListEndpoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.timelineStub.AccountListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SavingPotsActionCreator.handleAccountsListSuccess(body);
      },
      (error) => {
        SavingPotsActionCreator.handleAccountsListError(error);
      }
    );
  },
  getPotsData(accid, movemoney) {
    let url = envConfig.apiBaseUrlPAAS + _getPotsDataEndpoint;
    url = url.replace('{account-id}', accid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        if (movemoney) {
          SavingPotsActionCreator.handlePotDataSuccessForMovemoney(body);
        } else {
          SavingPotsActionCreator.handlePotDataSuccess(body);
          AccountsActionCreator.resetRejigIconSavingsPots(body, accid);
        }
      },
      (error) => {
        SavingPotsActionCreator.handlePotDataError(error);
      }
    );
  },
  getSinglePotData(potid, accid) {
    let url = envConfig.apiBaseUrlPAAS + _singlePotEndPoint;
    url = url.replace('{account-id}', accid);
    url = url.replace('{pot-id}', potid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SavingPotsActionCreator.handleSinglePotDataSuccess(body);
      },
      (error, status) => {
        SavingPotsActionCreator.handleSinglePotDataError(error, status);
      }
    );
  },
  getCreatePotData(newdata, accid) {
    const requestData = newdata;
    let url = envConfig.apiBaseUrlPAAS + _getPotsDataEndpoint;
    url = url.replace('{account-id}', accid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        MoveMoneyActionCreator.getPotDetails(accid);
        SavingPotsActionCreator.handleCreatedPotDataSuccess(body);
      },
      (error, status) => {
        SavingPotsActionCreator.handleCreatedPotDataError(error, status);
      }
    );
  },
  deletePotConnection(potid, accid) {
    let url = envConfig.apiBaseUrlPAAS + _singlePotEndPoint;
    url = url.replace('{account-id}', accid);
    url = url.replace('{pot-id}', potid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'DELETE',
        url,
        addAuthToken: true,
      },
      () => {
        AccountsActionCreator.getAccountDetails(accid);
        MoveMoneyActionCreator.getPotDetails(accid);
        SavingPotsActionCreator.getPotData();
      }
    );
  },
  editPotConnection(potid, accid, editedData) {
    const requestData = editedData;
    let url = envConfig.apiBaseUrlPAAS + _singlePotEndPoint;
    url = url.replace('{account-id}', accid);
    url = url.replace('{pot-id}', potid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        MoveMoneyActionCreator.getPotDetails(accid);
        SavingPotsActionCreator.handleSinglePotDataSuccess(body);
      },
      (error) => {
        SavingPotsActionCreator.handleSinglePotDataError(error);
      }
    );
  },
  getInterPotData(newdata, accid) {
    const requestData = newdata;
    let url = envConfig.apiBaseUrlPAAS + _interPotEndPoint;
    url = url.replace('{account-id}', accid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      () => {
        MoveMoneyActionCreator.getPotDetails(accid);
        SavingPotsActionCreator.getInterPotDataSuccess();
      },
      (error) => {
        SavingPotsActionCreator.getInterPotDataError(error);
      }
    );
  },
};

export const isSavingsPotsActive = () =>
  envConfig.isSavingsPotsEnabled && !UserManagementStore.isSMEUser();

export default SavingsPotsUtils;
